import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { useDataFlowResponseOptions } from '../use-data-flow-response-options/use-data-flow-response-options';
import type { Option } from '../use-option-cache/use-option-cache';

export const useLocationOptions = () => {
  const { i18n } = useTranslation();

  const initialCountries = useMemo<Option[]>(() => {
    const countries = i18n.getDataByLanguage(i18n.language)?.countries || {};

    return Object.entries(countries).map(([code, country]) => ({
      value: code,
      label: country,
    }));
  }, [i18n]);

  return useDataFlowResponseOptions(null, initialCountries);
};
